import { useRouter } from 'next/navigation'

import { RichText, Image } from '@src/quince-components/src'
import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import NewLongFormModuleCTA, { makeButtonProps } from '@src/quince-site-pdp/src/molecules/newLongFormModuleCTA'

import { getCardProps, makeRichTextProps } from '../rowOfImageTextBlocks.helpers'
import styles from '../rowOfImageTextBlocks.module.scss'

interface SubSectionProps {
  subSectionDetails: CustomSection
  layoutType?: LAYOUT_TYPES
  isFS2?: boolean
}

const SubSection = ({ subSectionDetails, layoutType, isFS2 }: SubSectionProps) => {
  const { imageUrl, imageTitle, iconUrl, iconTitle } = getCardProps({ subSectionDetails, isFS2 })

  const descriptionProps = makeRichTextProps(subSectionDetails)
  const button = subSectionDetails.buttons?.[0]

  const buttonProps = makeButtonProps(button)
  const href = buttonProps?.href

  const deviceInfo = useDeviceInfo()
  const router = useRouter()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE

  const handleClick = () => {
    if (href) {
      router.push(href)
    }
  }

  return (
    <div
      key={subSectionDetails.id}
      style={{
        cursor: href ? 'pointer' : 'auto',
        width: isMobile && (layoutType === LAYOUT_TYPES.CAROUSEL || isFS2) ? '24rem' : '100%',
        marginRight: isMobile && (layoutType === LAYOUT_TYPES.CAROUSEL || isFS2) ? '1.6rem' : 'auto',
      }}
      className={styles.imageAndTextBlock}
      onClick={handleClick}
    >
      <Image alt={imageTitle} url={imageUrl} className={styles.image} title={imageTitle ?? ''} />
      {iconUrl && <Image alt={iconTitle} url={iconUrl} className={styles.icon} title={iconTitle ?? ''} />}
      <h6>{subSectionDetails.displayTitle ?? ''}</h6>
      {descriptionProps && <RichText {...descriptionProps} />}
      {button && <NewLongFormModuleCTA button={button} />}
    </div>
  )
}

export default SubSection
